// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "ticketExample-12zd4";
export { _1 as "__esModule", _2 as "ticketExample" }
export default { "__esModule": _1, "ticketExample": _2 }
